// src/services/consentService.js
import { db, serverTimestamp } from "../firebase";
import { collection, addDoc } from "firebase/firestore";
import { logger } from "../utils/logger";

/**
 * Logs cookie consent choices to Firestore for audit trail
 * This is required for GDPR/CNIL compliance
 */
export async function logConsentChoice(preferences, userId = null, userAgent = null) {
  try {
    const consentLog = {
      preferences: {
        essential: preferences.essential ?? true,
        functional: preferences.functional ?? false,
      },
      userId: userId || null,
      userAgent: userAgent || (typeof navigator !== "undefined" ? navigator.userAgent : null),
      ipAddress: null, // Not collected client-side for privacy
      timestamp: serverTimestamp(),
      source: "cookie_banner", // 'cookie_banner', 'footer_link', 'modal'
    };

    await addDoc(collection(db, "consent_logs"), consentLog);
    logger.log("✅ Consent choice logged to Firestore");
  } catch (error) {
    // Don't block user experience if logging fails
    console.error("⚠️ Failed to log consent choice:", error);
  }
}

